<template>
  <screen
    :screen-info="$t('mobileScan.check_info')"
    :show-intro="false"
    :can-skip="true"
    :skip-text="$t('choose.tutorial')"
    @skip="tutorial"
    @leave="leave"
    center-titles
    scrollable
  >
    <img
      class="main-img"
      :class="currentCheck.classes"
      :src="currentCheck.img"
      :alt="currentCheck.info"
    />
    <check-item v-for="(c, i) in checkList" :key="i" :item="c" @checked="onItemCheck(i)" />
    <c-button :confirmed-status="passed" class="mt-4" @click="next">
      <span>{{ $t('mobileScan.start_scan') }}</span>
    </c-button>
  </screen>
</template>

<script>
import leave from '@/mixins/leave';
import audioPlayer from '@/mixins/audio-player';
import Screen from '@/components/common/Screen.vue';
import CButton from '@/components/common/CButton.vue';
import CheckItem from '@/components/MobileScan/Tutorial/CheckItem.vue';
import img1 from '@/assets/MobileScan/ready-to-scan-1.png';
import img2 from '@/assets/MobileScan/ready-to-scan-2.png';
import img3 from '@/assets/MobileScan/ready-to-scan-3.png';

export default {
  name: 'CheckList',
  components: {
    Screen,
    CButton,
    CheckItem,
  },
  mixins: [leave, audioPlayer],
  data: vm => ({
    index: 0,
    checkList: [
      // FIXME: fix flashes
      { info: vm.$t('mobileScan.wear_tight'), img: img1, checked: false },
      { info: vm.$t('mobileScan.wipe_front'), img: img2, checked: false },
      { info: vm.$t('mobileScan.volume_up'), img: img3, checked: false },
    ],
  }),
  methods: {
    onItemCheck(index) {
      const item = this.checkList[index];
      this.$set(item, 'checked', true);
      const nextIndex = this.checkList.findIndex(c => !c.checked);
      this.index = nextIndex > -1 ? nextIndex : index;
    },
    tutorial() {
      this.stopAudio();
      this.$events.goto('MobileScan2/Tutorial');
    },
    next() {
      this.stopAudio();
      this.$events.goto('MobileScan2/Scan');
    },
  },
  computed: {
    currentCheck() {
      return this.checkList[this.index];
    },
    passed() {
      return this.checkList.every(c => c.checked);
    },
  },
  watch: {
    show: {
      handler(nv) {
        if (nv) {
          this.playAudio('ms-09-about_to_start', true);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.main-img {
  @apply -mt-16 mb-3 p-6;
  min-height: 306px;
  max-height: 306px;
  min-width: 306px;
  max-width: 306px;
}
</style>
